import { render } from "./cell_click_copy.vue?vue&type=template&id=718ef4a1"
import script from "./cell_click_copy.vue?vue&type=script&lang=ts"
export * from "./cell_click_copy.vue?vue&type=script&lang=ts"
script.render = render

export default script